import { render, staticRenderFns } from "./ElementCollapse.vue?vue&type=template&id=719a6268&scoped=true"
import script from "./ElementCollapse.vue?vue&type=script&lang=js"
export * from "./ElementCollapse.vue?vue&type=script&lang=js"
import style0 from "./ElementCollapse.vue?vue&type=style&index=0&id=719a6268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a6268",
  null
  
)

export default component.exports